module.exports = __webpack_public_path__ + "img/logo-min.27dc0774.svg";